import React, { forwardRef } from 'react';
import { ICON_SIZE } from '../../styled';
export default forwardRef((props, ref) => (<img width={ICON_SIZE} height={ICON_SIZE} ref={ref} src={require('@images/embed/back.svg')} style={Object.assign({ cursor: 'pointer' }, (props.style || {}))} {...props}/>));
